import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@perval/shared';
import { catchError, firstValueFrom, map, of } from 'rxjs';
import { Siret } from '../../models/siret.model';
import { SiretHttp } from '../../models/siret-http.dto';
import { fromSiretHttpToSiret } from '../../mappers/siret.mapper';
import { ErrorStateService } from '../../../rapport/state/error-state.service';

@Injectable({
  providedIn: 'root',
})
export class SiretService {
  private readonly mainUrl = `${environment.baseApiUrl}/perval-utilisateurs`;

  constructor(
    private http: HttpClient,
    private readonly errorStateService: ErrorStateService,
  ) {}

  public async verifySiret(siret: string): Promise<Siret | null> {
    return firstValueFrom(
      this.http
        .get<SiretHttp>(`${this.mainUrl}/organizations/siret/${siret}`)
        .pipe(
          map(fromSiretHttpToSiret),
          catchError((error) => {
            this.errorStateService.setError(
              error?.error?.errors[0]?.message,
              false,
              error?.status,
            );
            return of(null);
          }),
        ),
    );
  }
}
